export default __webpack_public_path__ + "static/media/loan-finance.01b8d052.svg";